<template>
  <div>
    <div v-if="images.length">
      <h3 class="ut-text-lg ut-mb-4">Photos</h3>
      <div class="">
        <gallery :images="images" :index="index" @close="index = null" />
        <div v-for="(photo, i) in images" :key="i"
          @click="index = i"
          class="ut-inline-flex photos-list">
          <div class="photo ut-relative" v-if="i < totalImage">
            <div v-if="i === (totalImage-1) && images.length > totalImage"
              class=" ut-absolute ut-text-neutral-001 ut-z-50 ut-inset-auto front-text">
              +{{images.length - totalImage}}
            </div>
            <div v-if="i === (totalImage-1) && images.length > totalImage"
              class="ut-bg-dark-green-400 ut-z-40 ut-absolute ut-pin ut-opacity-75 ut-m-0">
            </div>
            <img :src="photo" class="" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import VueGallery from 'vue-gallery';

export default {
  name: 'PropertyPhotos',
  components: {
    gallery: VueGallery,
  },
  data() {
    return {
      index: null,
      propertyPhotos: [],
      window: {
        width: 0,
        height: 0,
      },
    };
  },
  props: {
    propertyAddressId: {
      required: true,
    },
    images: {
      required: true,
    },
  },
  mounted() {
  },
  created() {
    this.window.width = window.innerWidth;
    this.window.height = window.innerHeight;
    window.addEventListener('resize', this.handleResize);
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
  },
  computed: {
    totalImage() {
      const windowWidth = this.window.width;
      const totalPhotos = 4;
      if (windowWidth <= 576) {
        return 2;
      }

      if (windowWidth <= 768) {
        return 3;
      }

      return totalPhotos;
    },
  },
};
</script>

<style scoped lang="scss">

.front-text{
  top: 40%;
  right: 42%;
}

.photos-list {
  .photo {
    @apply ut-m-0 ut-mr-3 ut-h-24 ut-rounded ut-overflow-hidden ut-cursor-pointer;
    max-width: 145px;
  }
}

</style>
